/* @flow */
import * as React from 'react';

import GroupMemberFamily from 'groups/components/GroupMemberFamily';

import getField from '../ComposableTableField';
import type { Field } from '../ComposableTableField';

export function getFamilyCellGenerator(field: Field, groupMemberFamilyProps: Function) {
  return (data: Object) => {
    const cellProps = { familySummary: getField(data, field), ...groupMemberFamilyProps(data) };
    return <GroupMemberFamily {...cellProps} />;
  };
}
